import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Container, Card, Icon, AppBar, Toolbar } from "@mui/material";
import { fadeInUp } from "../../utils/animations";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";

import IconImage from "assets/images/logo.png";

const sections = [
  {
    title: "1. Responsable du traitement",
    content:
      "La plateforme ConformIMF est la propriété de Monsieur Guy Modeste EHOULO, Expert en Audit, Conformité & Microfinance. Elle regroupe les différents textes réglementaires publiés par les institutions de l\u2019espace UEMOA. En tant que responsable du traitement, M. EHOULO veille au respect de la confidentialité de vos données personnelles. Contact : ehoulogm@yahoo.fr - Tél. : +229 01 66 36 65 22.",
  },
  {
    title: "2. Collecte des données personnelles",
    content:
      "Dans le cadre de l\u2019utilisation de la plateforme ConformIMF, nous collectons les données suivantes : nom, adresse email professionnelle, institution de rattachement, rôle au sein de l\u2019institution. Ces données sont collectées lors de la création de votre compte par votre administrateur. Pour les visiteurs, les données collectées via le formulaire de contact (nom, email, sujet, message) et la newsletter (email) sont traitées conformément aux présentes.",
  },
  {
    title: "3. Finalité du traitement",
    content:
      "Les données collectées sont utilisées exclusivement pour : l\u2019authentification et la gestion de l\u2019accès à la plateforme, la personnalisation de votre expérience utilisateur, l\u2019envoi de notifications réglementaires pertinentes, la gestion administrative des comptes utilisateurs, la diffusion de la newsletter aux abonnés, le traitement des demandes de contact, et l\u2019établissement de statistiques anonymisées d\u2019utilisation.",
  },
  {
    title: "4. Durée de conservation",
    content:
      "Vos données personnelles sont conservées pendant toute la durée de votre utilisation de la plateforme. Les données de la newsletter sont conservées jusqu\u2019à votre désinscription. Les messages de contact sont conservés pendant une durée maximale de 12 mois. En cas de suppression de votre compte, vos données sont effacées dans un délai de 30 jours, à l\u2019exception des données nécessaires au respect d\u2019obligations légales.",
  },
  {
    title: "5. Droits des utilisateurs",
    content:
      "Conformément à la réglementation en vigueur dans l\u2019espace UEMOA et aux lois applicables en République du Bénin, vous disposez des droits suivants : droit d\u2019accès à vos données personnelles, droit de rectification des données inexactes, droit de suppression de vos données, droit d\u2019opposition au traitement, droit de désinscription de la newsletter. Pour exercer ces droits, contactez-nous à l\u2019adresse : ehoulogm@yahoo.fr.",
  },
  {
    title: "6. Sécurité des données",
    content:
      "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement des communications (HTTPS/TLS), hashage sécurisé des mots de passe (Argon2), contrôle d\u2019accès basé sur les rôles (RBAC), protection CSRF sur les formulaires, journalisation des accès et actions, authentification par jetons JWT signés.",
  },
  {
    title: "7. Partage des données",
    content:
      "Vos données personnelles ne sont jamais vendues ni partagées avec des tiers à des fins commerciales. Elles peuvent être communiquées uniquement aux administrateurs autorisés de votre institution et aux autorités compétentes sur demande judiciaire.",
  },
  {
    title: "8. Cookies",
    content:
      "La plateforme utilise un cookie de session HttpOnly strictement n\u00e9cessaire \u00e0 l\u2019authentification (jeton JWT). Ce cookie est s\u00e9curis\u00e9 (HttpOnly, SameSite=Strict) et ne peut pas \u00eatre lu par des scripts JavaScript. Aucun cookie de tra\u00e7age publicitaire n\u2019est utilis\u00e9. Un jeton CSRF technique est utilis\u00e9 pour s\u00e9curiser les formulaires contre les attaques cross-site.",
  },
  {
    title: "9. Modifications",
    content:
      "La présente politique de confidentialité peut être mise à jour à tout moment. Les utilisateurs seront informés de toute modification substantielle par notification sur la plateforme. Date de dernière mise à jour : 2 avril 2026.",
  },
];

function PolitiqueConfidentialite() {
  return (
    <PageLayout>
      <Helmet>
        <title>Politique de confidentialité - ConformIMF</title>
        <meta
          name="description"
          content="Politique de confidentialité de ConformIMF : traitement des données personnelles, droits des utilisateurs, cookies et mesures de sécurité mises en place."
        />
        <meta property="og:title" content="Politique de confidentialité - ConformIMF" />
        <meta
          property="og:description"
          content="Politique de confidentialité de ConformIMF : traitement des données personnelles, droits des utilisateurs et sécurité."
        />
        <meta property="og:url" content="https://conformimf.com/politique-confidentialite" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Politique de confidentialité - ConformIMF" />
        <meta
          name="twitter:description"
          content="Politique de confidentialité de ConformIMF : traitement des données personnelles, droits des utilisateurs et sécurité."
        />
      </Helmet>

      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(16px)",
          boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
          py: 0.5,
          zIndex: 1100,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between", px: "0 !important" }}>
            <MDBox
              component={Link}
              to="/"
              display="flex"
              alignItems="center"
              sx={{ textDecoration: "none" }}
            >
              <MDBox component="img" src={IconImage} alt="Logo" width="200px" sx={{ mr: 1.5 }} />
            </MDBox>
            <MDButton
              variant="gradient"
              color="purple"
              size="small"
              component={Link}
              to="/"
              sx={{
                px: 3,
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-2px)" },
              }}
            >
              <Icon sx={{ mr: 0.5 }}>arrow_back</Icon>
              Accueil
            </MDButton>
          </Toolbar>
        </Container>
      </AppBar>

      <MDBox sx={{ pt: 12, pb: 6, minHeight: "100vh", backgroundColor: "#fafafa" }}>
        <Container maxWidth="md">
          <MDBox textAlign="center" mb={5} sx={{ animation: `${fadeInUp} 0.6s ease-out both` }}>
            <Icon sx={{ fontSize: "48px !important", color: "#186A81", mb: 2 }}>security</Icon>
            <MDTypography variant="h2" fontWeight="bold" mb={1}>
              Politique de confidentialité
            </MDTypography>
            <MDTypography variant="body1" color="text" sx={{ opacity: 0.8 }}>
              Comment ConformIMF protège vos données personnelles.
            </MDTypography>
          </MDBox>

          {sections.map((section, i) => (
            <Card
              key={i}
              sx={{
                p: 3.5,
                mb: 2.5,
                borderRadius: "16px",
                animation: `${fadeInUp} 0.5s ease-out ${0.1 + i * 0.08}s both`,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(123,31,162,0.08)",
                },
              }}
            >
              <MDBox display="flex" alignItems="center" mb={1.5}>
                <Icon sx={{ color: "#186A81", mr: 1.5, fontSize: "22px" }}>shield</Icon>
                <MDTypography variant="h6" fontWeight="bold">
                  {section.title}
                </MDTypography>
              </MDBox>
              <MDTypography
                variant="body2"
                color="text"
                sx={{ lineHeight: 1.8, opacity: 0.85, pl: 4.5 }}
              >
                {section.content}
              </MDTypography>
            </Card>
          ))}
        </Container>

        <MDBox textAlign="center" mt={8}>
          <MDTypography variant="caption" color="text" sx={{ opacity: 0.5 }}>
            &copy; 2026 ConformIMF - Guy Modeste EHOULO - Tous droits réservés
          </MDTypography>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

export default PolitiqueConfidentialite;
